import { MapApp } from './MapApp';
import { Movax } from './Movax';
import { ImageGallery } from './ImageGallery';
import { CoveringImage } from './CoveringImage';

var $ = require('jquery');

export module ReferencesApp {
  export function init(containerSelector:string, containerClass:string) {
    var map = new MapApp(containerSelector, containerClass, {
      scrollToActiveSingleView: true
    });

    // Reinit some components when view is loaded
    map.setSingleViewActiveCallback(function (viewElement) {
      var $element = $(viewElement);

      $element.find('.js-covering-image').each(function() {
        var coveringImage = new CoveringImage(this, 'covering-image', 100);
        coveringImage.init();
      });

      $element.find('.js-image-gallery').each(function() {
        var imageGallery = new ImageGallery(this, 'image-gallery');
        imageGallery.init();
      });

      // just to make sure everything loads
      setTimeout(function () {
        Movax.events.triggerResize();
      }, 100);
    });

    /**
     * This is called every time filtering options are changed
     */
    map.setFilteringHandler(function(filters, categories) {
      var filterCounter = 0,
          filteredList = [],
          key,
          i, j;

      for(key in filters) {
        if (filters.hasOwnProperty(key)) {
          filterCounter++;

          switch(key) {
            case 'category':

              // Filter by category
              if (typeof filters[key] === 'object' && filters[key].length) {
                filteredList = filteredList.concat(categories.filter(function(category) {
                  var i, l;
                  for (i = 0, l = filters[key].length; i < l; i++) {
                    if(category.slug === filters[key][i]) {
                      return true;
                    }
                  }

                  return false;
                }))
              }
              break;
          }
        }
      }

      // if no filters are active, show all
      if(filterCounter === 0) {
        filteredList = categories;
      }

      return filteredList;
    });

    map.init();
  }
}
